<template>
  <div class="caseDetail">
    <van-tabs v-model="active">
      <van-tab title="申请人" name="applicant">
        <div class="infoContent">
          <div class="orgContent">已选择机构：{{caseDetailData.orgName}}</div>
          <div class="informationItem" v-for="(applyUser, applyIndex) in caseDetailData.applyUserList">
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap infoCell">
                  <div class="applyInfoTitle">申请人信息</div>
                  <van-cell-group>
                    <van-cell title="申请人" v-if="applyUser.userType == 'NATURAL_PERSON'"  value="自然人" />
                    <van-cell title="申请人" v-else-if="applyUser.userType == 'JURIDICAL_PERSON'"  value="企业" />
                    <van-cell title="申请人" v-else-if="applyUser.userType == 'UNINCORPORATED_ORGANIZATION'"  value="非法人组织" />
                    <van-cell title="公司名称" v-if="applyUser.userType != 'NATURAL_PERSON'" :value="applyUser.companyName" />
                    <van-cell title="法人代表" v-if="applyUser.userType != 'NATURAL_PERSON'" :value="applyUser.corporation" />
                    <van-cell title="法人代表电话" v-if="applyUser.userType != 'NATURAL_PERSON'" :value="applyUser.corporationPhone" />
                    <van-cell title="联系人"  :value="applyUser.userName" />
                    <van-cell title="联系人电话"  :value="applyUser.phone" />
                    <van-cell title="联系地址"  :value="applyUser.detailAddress" />
                    <van-cell title="国家"  :value="applyUser.countryName" />
                    <van-cell title="电子邮件"  :value="applyUser.email" />
                    <van-cell title="传真"  :value="applyUser.fax" />
                    <van-cell title="邮编"  :value="applyUser.zipCode" />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <div class="information" v-for="(agent, agentIndex) in applyUser.agentList">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <div class="applyInfoTitle">代理人信息</div>
                  <van-cell-group>
                    <van-cell title="代理人"  :value="agent.userName" />
                    <van-cell title="代理人电话"  :value="agent.phone" />
                    <van-cell title="联系地址"  :value="agent.detailAddress" />
                    <van-cell title="电子邮件"  :value="agent.email" />
                    <van-cell title="传真"  :value="agent.fax" />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <div class="applyInfoTitle">共同申请</div>
                  <van-cell-group>
                    <van-cell title="是否为共同申请" class="moneyTip"  :value="caseDetailData.isJointApplication==1?'是':'否'" />
                  </van-cell-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="被申请人" name="respondent">
        <div class="infoContent">
          <div class="orgContent">已选择机构：{{caseDetailData.orgName}}</div>
          <div class="informationItem" v-for="(respondentUser, respondentIndex) in caseDetailData.respondentUserList">
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap infoCell">
                  <div class="applyInfoTitle">被申请人信息</div>
                  <van-cell-group>
                    <van-cell title="被申请人" v-if="respondentUser.userType == 'NATURAL_PERSON'"  value="自然人" />
                    <van-cell title="被申请人" v-else-if="respondentUser.userType == 'JURIDICAL_PERSON'"  value="企业" />
                    <van-cell title="被申请人" v-else-if="respondentUser.userType == 'UNINCORPORATED_ORGANIZATION'"  value="非法人组织" />
                    <van-cell title="公司名称" v-if="respondentUser.userType != 'NATURAL_PERSON'" :value="respondentUser.companyName" />
                    <van-cell title="法人代表" v-if="respondentUser.userType != 'NATURAL_PERSON'" :value="respondentUser.corporation" />
                    <van-cell title="法人代表电话" v-if="respondentUser.userType != 'NATURAL_PERSON'" :value="respondentUser.corporationPhone" />
                    <van-cell title="联系人"  :value="respondentUser.userName" />
                    <van-cell title="联系人电话"  :value="respondentUser.phone" />
                    <van-cell title="联系地址"  :value="respondentUser.detailAddress" />
                    <van-cell title="国家"  :value="respondentUser.countryName" />
                    <van-cell title="电子邮件"  :value="respondentUser.email" />
                    <van-cell title="传真"  :value="respondentUser.fax" />
                    <van-cell title="邮编"  :value="respondentUser.zipCode" />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <div class="information" v-for="(agent, agentIndex) in respondentUser.agentList">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <div class="applyInfoTitle">代理人信息</div>
                  <van-cell-group>
                    <van-cell title="代理人"  :value="agent.userName" />
                    <van-cell title="代理人电话"  :value="agent.phone" />
                    <van-cell title="联系地址"  :value="agent.detailAddress" />
                    <van-cell title="电子邮件"  :value="agent.email" />
                    <van-cell title="传真"  :value="agent.fax" />
                  </van-cell-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="争议内容" name="dispute">
        <div class="infoContent">
          <div class="orgContent">已选择机构：{{caseDetailData.orgName}}</div>
          <div class="informationItem">
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <div class="applyInfoTitle">基本事实</div>
                  <van-cell-group>
                    <van-field type="textarea" :value="caseDetailData.appeal" readonly />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <div class="applyInfoTitle">争议要点</div>
                  <van-cell-group>
                    <van-field type="textarea" :value="caseDetailData.disputeContent" readonly />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <div class="applyInfoTitle">调解请求</div>
                  <van-cell-group>
                    <van-field type="textarea" :value="caseDetailData.mediationRequest" readonly />
                  </van-cell-group>
                </div>
              </div>
            </div>
            <div class="information">
              <div class="applyInfoWrap">
                <div class="infoWrap">
                  <van-cell-group>
                    <van-cell class="moneyTip" title="争议金额(RMB)"  :value="caseDetailData.amount+' 元'" />
                    <van-cell class="moneyTip" title="预估管理费(RMB)"  :value="caseDetailData.manageFee+' 元'" />
                  </van-cell-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script type="text/ecmascript-6">
import config from '@/config/config';
import { setTimeout } from 'timers';
import { getStore, dateformat } from '@/utils/utils';

export default {
  props: ['caseDetailData'],
  data() {
    return {
      active: 'applicant',
    };
  },
  mounted() {
  },
  created() {
    this.active = this.$route.query.tap;
  },
  methods: {
  },
};
</script>

<style rel="stylesheet/scss" scoped lang="scss">
.caseDetail{
  height: 100%;
  width: 100%;
  background: #F6F6F6;
  .van-tabs {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
  .van-tab--active {
    color: #376BFF;
  }
  .van-tabs__wrap{
    .van-tabs__line{
      background-color: #376BFF;
    }
  }
  .van-tabs__content{
    position: relative;
    height: 100%;

  }
  .infoContent {
      padding: 10px 15px;
    .orgContent {
      width: 100%;
      height: 35px;
      font-size: 15px;
      color: #376BFF;
      line-height: 35px;
      background: #fff;
      border-radius: 8px;
      text-align: center;
    }
    .informationItem {
      .information{
        width: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        margin-top: 10px;
        padding: 10px 0;
        .applyInfoWrap {
          width: 100%;
          .infoWrap{
            width: 100%;
            .van-hairline--top-bottom {
              .van-cell::after{
                left: 0;
                right: 0;
              }
            }
            .van-hairline--top-bottom::after{
              border: none;
            }
            .applyInfoTitle {
              height: 40px;
              font-size: 17px;
              font-weight: bold;
              color: #333333;
              line-height: 40px;
              padding-left: 15px;
              position: relative;
            }
            .applyInfoTitle:before {
              content: "";
              position: absolute;
              left: 0;
              top: 20px;
              margin-top: -10px;
              height: 18px;
              width: 4px;
              background-color: #376bff;
            }
            .van-cell {
              .van-cell__title {
                font-weight: 500;
                span {
                  font-weight: 500;
                }
              }
              .van-cell__value {
                color: #333;
              }
            }
            .moneyTip {
              .van-cell__value {
                text-align:right;
              }
            }
          }
          .infoCell {
            .van-cell {
              .van-cell__title {
                width: 75px;
              }
            }
          }
        }

      }
    }
  }
}
</style>
